// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.ProfessionalHeader_header__xxh8o {
  height: 64px;
  display: block;
  padding: 0;
  margin: 0 0 12px;
  background-color: #F7F5F1;
  border: 1px solid rgba(19, 35, 29, 0.08);
  border-radius: 18px;
  box-shadow: 0 7px 20px rgba(0, 0, 0, 0.025);
  color: #13231d;
  width: 100%;
  position: sticky;
  top: 18px;
  z-index: 60;
}
@media (max-width: 1024px) {
  .ProfessionalHeader_header__xxh8o {
    height: 60px;
    min-height: 60px;
    padding: 0 16px;
    border-radius: 0;
    margin-top: -70px;
    margin-bottom: 20px;
    position: sticky;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    z-index: 100;
    border-left: none;
    border-right: none;
    border-top: none;
  }
}
.ProfessionalHeader_header__mobile-title__\\+0XSA {
  display: none;
  font-size: 15px;
  font-weight: 700;
  color: #13231d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 8px;
}
@media (max-width: 1024px) {
  .ProfessionalHeader_header__mobile-title__\\+0XSA {
    display: block;
    flex: 1 1;
    margin: 0;
  }
}
.ProfessionalHeader_header__content__zmtzg {
  position: relative;
  width: 100%;
  min-height: 62px;
  display: flex;
  align-items: center;
}
@media (max-width: 1024px) {
  .ProfessionalHeader_header__content__zmtzg {
    min-height: unset;
    width: auto;
    flex: 0 0 auto;
    margin-left: auto;
  }
}
@media (min-width: 1025px) {
  .ProfessionalHeader_header__magic-align__9s-7Z {
    margin-left: -275px;
    margin-right: -23px;
    width: calc(100% + 274px + 22px + 2px);
    pointer-events: none;
  }
}
@media (max-width: 1024px) {
  .ProfessionalHeader_header__magic-align__9s-7Z {
    width: auto;
    padding: 0;
    margin: 0;
  }
}
@media (max-width: 1024px) {
  .ProfessionalHeader_header__xxh8o div[class*=actions] {
    display: flex !important;
    width: auto !important;
    gap: 10px !important;
    margin-left: auto !important;
  }
  .ProfessionalHeader_header__xxh8o div[class*=action-item] {
    display: none !important;
  }
  .ProfessionalHeader_header__xxh8o .bw-signed-actions {
    display: flex !important;
    gap: 10px !important;
  }
  .ProfessionalHeader_header__xxh8o .bw-header-user strong {
    display: none;
  }
}
.ProfessionalHeader_header__nav__npD9z {
  display: flex;
  align-items: center;
  gap: 24px;
}
@media (max-width: 980px) {
  .ProfessionalHeader_header__nav__npD9z {
    display: none;
  }
}
.ProfessionalHeader_header__nav-link__brQRk {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 12px;
  white-space: nowrap;
  font-size: 16px;
  line-height: 1.2;
  color: #13231d;
  font-weight: 600;
  /* made slightly bolder to match mockup */
  border-radius: 12px;
  text-decoration: none;
  transition: color 0.2s ease, background-color 0.2s ease, opacity 0.2s ease;
}
.ProfessionalHeader_header__nav-link__brQRk:hover, .ProfessionalHeader_header__nav-link__brQRk.ProfessionalHeader_is-active__qbpcg {
  color: #82b194;
  background: rgba(130, 177, 148, 0.1);
}
.ProfessionalHeader_header__actions__2efwA {
  display: flex;
  align-items: center;
  gap: 22px;
  margin-left: auto;
}
.ProfessionalHeader_header__mobile-menu-button__Hz\\+t- {
  opacity: 0;
  background: transparent;
  border: none;
  color: #333;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.3s ease;
  transform: translateX(-100%);
  display: none;
}
@media (max-width: 768px) {
  .ProfessionalHeader_header__mobile-menu-button__Hz\\+t- {
    display: inline-flex;
    opacity: 1;
    transform: translateX(0);
    margin-right: 8px;
  }
}
.ProfessionalHeader_header__lang-selector__Qc9p0 {
  position: relative;
}
.ProfessionalHeader_header__lang-btn__DYSqH {
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-weight: 600;
  color: #4a5c54;
  font-size: 14px;
  padding: 6px 10px;
  border-radius: 8px;
  transition: background 0.2s;
}
.ProfessionalHeader_header__lang-btn__DYSqH:hover {
  background: rgba(0, 0, 0, 0.04);
}
.ProfessionalHeader_header__lang-dropdown__WPwSX {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 140px;
  margin-top: 8px;
  z-index: 10;
}
.ProfessionalHeader_header__lang-dropdown-item__-kqtY {
  background: none;
  border: none;
  padding: 8px 12px;
  text-align: left;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  color: #13231d;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: background 0.2s, color 0.2s;
}
.ProfessionalHeader_header__lang-dropdown-item__-kqtY:hover {
  background: #f5f5f5;
}
.ProfessionalHeader_header__lang-dropdown-item--active__KZ1gf {
  color: #597d67;
}
.ProfessionalHeader_header__lang-dropdown-item--active__KZ1gf .ProfessionalHeader_header__lang-dropdown-icon__rUrAr {
  background: rgba(130, 177, 148, 0.15);
  color: #597d67;
}
.ProfessionalHeader_header__lang-dropdown-icon__rUrAr {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: transparent;
  color: #13231d;
  font-size: 11px;
  font-weight: 700;
  transition: all 0.2s;
}
.ProfessionalHeader_header__profile-container__MKPwp {
  position: relative;
}
.ProfessionalHeader_header__profile-button__BF\\+vQ {
  background: none;
  border: none;
  display: flex;
  align-items: center;
  gap: 9px;
  cursor: pointer;
  font-weight: 700;
  color: #13231d;
  padding: 0;
  font-size: 14px;
  border-radius: 8px;
  transition: background 0.2s;
}
.ProfessionalHeader_header__profile-button__BF\\+vQ:hover {
  background: rgba(0, 0, 0, 0.04);
}
.ProfessionalHeader_header__profile-icon__Y\\+hdL {
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  border: 2px solid rgba(95, 120, 108, 0.68);
  border-radius: 50%;
  color: #5f786c;
}
.ProfessionalHeader_header__profile-icon__Y\\+hdL svg {
  width: 15px;
  height: 15px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.ProfessionalHeader_header__profile-dropdown__emQf6 {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 8px 0;
  min-width: 200px;
  display: none;
}
.ProfessionalHeader_header__profile-dropdown--open__rTPvr {
  display: block;
}
.ProfessionalHeader_header__dropdown-header__YCRRc {
  padding: 8px 16px;
}
.ProfessionalHeader_header__dropdown-header__YCRRc p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}
.ProfessionalHeader_header__dropdown-header__YCRRc .ProfessionalHeader_text-muted__q-IZm {
  font-weight: 400;
  font-size: 12px;
  color: #888;
}
.ProfessionalHeader_header__xxh8o hr {
  margin: 8px 0;
  border: 0;
  border-top: 1px solid #eee;
}
.ProfessionalHeader_header__profile-dropdown-item__CuTjt {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  color: #4a5c54;
  text-decoration: none;
  font-size: 14px;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
}
.ProfessionalHeader_header__profile-dropdown-item__CuTjt:hover {
  background: #f5f5f5;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/layouts/dashboard-layouts/style/ProfessionalHeader.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACE,YAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,yBAAA;EACA,wCAAA;EACA,mBAAA;EACA,2CAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;AAiBF;AAfE;EAfF;IAgBI,YAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;IACA,gBAAA;IACA,MAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,sBAAA;IACA,YAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;EAkBF;AACF;AAhBE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AAkBJ;AAhBI;EAVF;IAWI,cAAA;IACA,SAAA;IACA,SAAA;EAmBJ;AACF;AAhBE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAkBJ;AAhBI;EAPF;IAQI,iBAAA;IACA,WAAA;IACA,cAAA;IACA,iBAAA;EAmBJ;AACF;AAfI;EADF;IAEI,mBAAA;IACA,mBAAA;IACA,sCAAA;IACA,oBAAA;EAkBJ;AACF;AAhBI;EARF;IASI,WAAA;IACA,UAAA;IACA,SAAA;EAmBJ;AACF;AAhBE;EACE;IACE,wBAAA;IACA,sBAAA;IACA,oBAAA;IACA,4BAAA;EAkBJ;EAfE;IACE,wBAAA;EAiBJ;EAdE;IACE,wBAAA;IACA,oBAAA;EAgBJ;EAbE;IACE,aAAA;EAeJ;AACF;AAZE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAcJ;AAZI;EALF;IAMI,aAAA;EAeJ;AACF;AAZE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,yCAAA;EACA,mBAAA;EACA,qBAAA;EACA,0EAAA;AAcJ;AAZI;EAEE,cAAA;EACA,oCAAA;AAaN;AATE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAWJ;AARE;EACE,UAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,yBAAA;EACA,4BAAA;EACA,aAAA;AAUJ;AARI;EAhBF;IAiBI,oBAAA;IACA,UAAA;IACA,wBAAA;IACA,iBAAA;EAWJ;AACF;AARE;EACE,kBAAA;AAUJ;AAPE;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;AASJ;AAPI;EACE,+BAAA;AASN;AALE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,yCAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAOJ;AAJE;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uCAAA;AAMJ;AAJI;EACE,mBAAA;AAMN;AAHI;EACE,cAAA;AAKN;AAHM;EACE,qCAAA;EACA,cAAA;AAKR;AAAE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAEJ;AACE;EACE,kBAAA;AACJ;AAEE;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;AAAJ;AAEI;EACE,+BAAA;AAAN;AAIE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;AAFJ;AAII;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAFN;AAME;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,yCAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;AAJJ;AAMI;EACE,cAAA;AAJN;AAQE;EACE,iBAAA;AANJ;AAQI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AANN;AASI;EACE,gBAAA;EACA,eAAA;EACA,WAAA;AAPN;AAWE;EACE,aAAA;EACA,SAAA;EACA,0BAAA;AATJ;AAYE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAVJ;AAYI;EACE,mBAAA;AAVN","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n.header {\n  height: 64px;\n  display: block;\n  padding: 0;\n  margin: 0 0 12px;\n  background-color: #F7F5F1;\n  border: 1px solid rgba(19, 35, 29, 0.08);\n  border-radius: 18px;\n  box-shadow: 0 7px 20px rgba(0, 0, 0, 0.025);\n  color: #13231d;\n  width: 100%;\n  position: sticky;\n  top: 18px;\n  z-index: 60;\n\n  @media (max-width: 1024px) {\n    height: 60px;\n    min-height: 60px;\n    padding: 0 16px;\n    border-radius: 0;\n    margin-top: -70px;\n    margin-bottom: 20px;\n    position: sticky;\n    top: 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    z-index: 100;\n    border-left: none;\n    border-right: none;\n    border-top: none;\n  }\n\n  &__mobile-title {\n    display: none;\n    font-size: 15px;\n    font-weight: 700;\n    color: #13231d;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding-left: 8px;\n\n    @media (max-width: 1024px) {\n      display: block;\n      flex: 1;\n      margin: 0;\n    }\n  }\n\n  &__content {\n    position: relative;\n    width: 100%;\n    min-height: 62px;\n    display: flex;\n    align-items: center;\n\n    @media (max-width: 1024px) {\n      min-height: unset;\n      width: auto;\n      flex: 0 0 auto;\n      margin-left: auto;\n    }\n  }\n\n  &__magic-align {\n    @media (min-width: 1025px) {\n      margin-left: calc(-274px - 1px);\n      margin-right: calc(-22px - 1px);\n      width: calc(100% + 274px + 22px + 2px);\n      pointer-events: none;\n    }\n    \n    @media (max-width: 1024px) {\n      width: auto;\n      padding: 0;\n      margin: 0;\n    }\n  }\n\n  @media (max-width: 1024px) {\n    div[class*=\"actions\"] {\n      display: flex !important;\n      width: auto !important;\n      gap: 10px !important;\n      margin-left: auto !important;\n    }\n\n    div[class*=\"action-item\"] {\n      display: none !important;\n    }\n\n    :global(.bw-signed-actions) {\n      display: flex !important;\n      gap: 10px !important;\n    }\n\n    :global(.bw-header-user) strong {\n      display: none;\n    }\n  }\n\n  &__nav {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    \n    @media (max-width: 980px) {\n      display: none;\n    }\n  }\n\n  &__nav-link {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 40px;\n    padding: 0 12px;\n    white-space: nowrap;\n    font-size: 16px;\n    line-height: 1.2;\n    color: #13231d;\n    font-weight: 600;\n    /* made slightly bolder to match mockup */\n    border-radius: 12px;\n    text-decoration: none;\n    transition: color .2s ease, background-color .2s ease, opacity .2s ease;\n\n    &:hover,\n    &.is-active {\n      color: #82b194;\n      background: rgba(130, 177, 148, 0.10);\n    }\n  }\n\n  &__actions {\n    display: flex;\n    align-items: center;\n    gap: 22px;\n    margin-left: auto;\n  }\n\n  &__mobile-menu-button {\n    opacity: 0;\n    background: transparent;\n    border: none;\n    color: #333;\n    cursor: pointer;\n    width: 40px;\n    height: 40px;\n    border-radius: 8px;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    transition: all $transition-speed ease;\n    transform: translateX(-100%);\n    display: none;\n\n    @media (max-width: $breakpoint-md) {\n      display: inline-flex;\n      opacity: 1;\n      transform: translateX(0);\n      margin-right: 8px;\n    }\n  }\n\n  &__lang-selector {\n    position: relative;\n  }\n\n  &__lang-btn {\n    background: transparent;\n    border: none;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n    font-weight: 600;\n    color: #4a5c54;\n    font-size: 14px;\n    padding: 6px 10px;\n    border-radius: 8px;\n    transition: background 0.2s;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.04);\n    }\n  }\n\n  &__lang-dropdown {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    background: white;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    border-radius: 12px;\n    padding: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 140px;\n    margin-top: 8px;\n    z-index: 10;\n  }\n\n  &__lang-dropdown-item {\n    background: none;\n    border: none;\n    padding: 8px 12px;\n    text-align: left;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: 600;\n    color: #13231d;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    transition: background 0.2s, color 0.2s;\n\n    &:hover {\n      background: #f5f5f5;\n    }\n\n    &--active {\n      color: #597d67;\n\n      .header__lang-dropdown-icon {\n        background: rgba(130, 177, 148, 0.15);\n        color: #597d67;\n      }\n    }\n  }\n\n  &__lang-dropdown-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border-radius: 6px;\n    background: transparent;\n    color: #13231d;\n    font-size: 11px;\n    font-weight: 700;\n    transition: all 0.2s;\n  }\n\n  &__profile-container {\n    position: relative;\n  }\n\n  &__profile-button {\n    background: none;\n    border: none;\n    display: flex;\n    align-items: center;\n    gap: 9px;\n    cursor: pointer;\n    font-weight: 700;\n    color: #13231d;\n    padding: 0;\n    font-size: 14px;\n    border-radius: 8px;\n    transition: background 0.2s;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.04);\n    }\n  }\n\n  &__profile-icon {\n    width: 26px;\n    height: 26px;\n    display: grid;\n    place-items: center;\n    border: 2px solid rgba(95, 120, 108, .68);\n    border-radius: 50%;\n    color: #5f786c;\n\n    svg {\n      width: 15px;\n      height: 15px;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 1.8;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    }\n  }\n\n  &__profile-dropdown {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    background: white;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    padding: 8px 0;\n    min-width: 200px;\n    display: none;\n\n    &--open {\n      display: block;\n    }\n  }\n\n  &__dropdown-header {\n    padding: 8px 16px;\n\n    p {\n      margin: 0;\n      font-size: 14px;\n      font-weight: 600;\n    }\n\n    .text-muted {\n      font-weight: 400;\n      font-size: 12px;\n      color: #888;\n    }\n  }\n\n  hr {\n    margin: 8px 0;\n    border: 0;\n    border-top: 1px solid #eee;\n  }\n\n  &__profile-dropdown-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 16px;\n    color: #4a5c54;\n    text-decoration: none;\n    font-size: 14px;\n    background: none;\n    border: none;\n    width: 100%;\n    text-align: left;\n    cursor: pointer;\n\n    &:hover {\n      background: #f5f5f5;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `ProfessionalHeader_header__xxh8o`,
	"header__mobile-title": `ProfessionalHeader_header__mobile-title__+0XSA`,
	"header__content": `ProfessionalHeader_header__content__zmtzg`,
	"header__magic-align": `ProfessionalHeader_header__magic-align__9s-7Z`,
	"header__nav": `ProfessionalHeader_header__nav__npD9z`,
	"header__nav-link": `ProfessionalHeader_header__nav-link__brQRk`,
	"is-active": `ProfessionalHeader_is-active__qbpcg`,
	"header__actions": `ProfessionalHeader_header__actions__2efwA`,
	"header__mobile-menu-button": `ProfessionalHeader_header__mobile-menu-button__Hz+t-`,
	"header__lang-selector": `ProfessionalHeader_header__lang-selector__Qc9p0`,
	"header__lang-btn": `ProfessionalHeader_header__lang-btn__DYSqH`,
	"header__lang-dropdown": `ProfessionalHeader_header__lang-dropdown__WPwSX`,
	"header__lang-dropdown-item": `ProfessionalHeader_header__lang-dropdown-item__-kqtY`,
	"header__lang-dropdown-item--active": `ProfessionalHeader_header__lang-dropdown-item--active__KZ1gf`,
	"header__lang-dropdown-icon": `ProfessionalHeader_header__lang-dropdown-icon__rUrAr`,
	"header__profile-container": `ProfessionalHeader_header__profile-container__MKPwp`,
	"header__profile-button": `ProfessionalHeader_header__profile-button__BF+vQ`,
	"header__profile-icon": `ProfessionalHeader_header__profile-icon__Y+hdL`,
	"header__profile-dropdown": `ProfessionalHeader_header__profile-dropdown__emQf6`,
	"header__profile-dropdown--open": `ProfessionalHeader_header__profile-dropdown--open__rTPvr`,
	"header__dropdown-header": `ProfessionalHeader_header__dropdown-header__YCRRc`,
	"text-muted": `ProfessionalHeader_text-muted__q-IZm`,
	"header__profile-dropdown-item": `ProfessionalHeader_header__profile-dropdown-item__CuTjt`
};
export default ___CSS_LOADER_EXPORT___;
